import script from "./LogoutDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutDialog.vue?vue&type=script&setup=true&lang=js"

import "./LogoutDialog.vue?vue&type=style&index=0&id=13d427fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13d427fe"]])

export default __exports__